import { render, staticRenderFns } from "./DiagramAgeStacked.vue?vue&type=template&id=6c78f4ff&scoped=true&"
import script from "./DiagramAgeStacked.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DiagramAgeStacked.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./DiagramAgeStacked.vue?vue&type=style&index=0&id=6c78f4ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c78f4ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c78f4ff')) {
      api.createRecord('6c78f4ff', component.options)
    } else {
      api.reload('6c78f4ff', component.options)
    }
    module.hot.accept("./DiagramAgeStacked.vue?vue&type=template&id=6c78f4ff&scoped=true&", function () {
      api.rerender('6c78f4ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/common/DiagramAgeStacked.vue"
export default component.exports